export enum EList {
  verification = 'verification',
  history = 'history',
  team = 'team',
  list = 'list',
  edit = 'edit',
}
